import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  masterData: object;
  settingMasterData: object;
  DocumentMasterData: object;
  DropdownMasterData: object;
  DocumentMasterOptions: object;
  DocumentMasterEditData: object;
  error: string;
}

const initialArgs: Master = {
  masterData: {},
  settingMasterData: {},
  DocumentMasterData: {},
  DropdownMasterData: {},
  DocumentMasterOptions: {},
  DocumentMasterEditData: {},
  error: "",
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useDocumentMaster = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getDocumentMasterOptions = async (
    page: string,
    pageSize: string,
    searchValue: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/document-master/?page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DocumentMasterData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateDocumentMaster = async (param: any, dropdownid: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.put(
        `/api/document-master/${dropdownid}`,
        paramObj,
      );

      if (result.data.status) {
        // setState({ ...state, documentMasterEditData: result.data.data });
        toast.success("Document Master has been updated successfully");
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const editDocumentMaster = async (documentMasterId: string) => {
    console.log("dropdownMasterId => ", documentMasterId);

    try {
      const result: any = await api.get(
        `/api/document-master/${documentMasterId}`,
      );
      console.log(" result=> ", result.data.data);

      if (result.data.status) {
        setState({ ...state, DocumentMasterEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createDocumentMaster = async (param: any) => {
    const paramObj = {
      ...param,
    };
    console.log("paramObj => ", paramObj);

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/document-master", paramObj);
      console.log("resultfromPostApi => ", result);

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Document Master has been added successfully");
        setState({ ...state, masterData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getDocumentMasterSlug = async () => {
    try {
      const result: any = await api.get(
        `/api/setting-category/type?slug=document`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DocumentMasterOptions: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  return {
    getDocumentMasterOptions,
    updateDocumentMaster,
    editDocumentMaster,
    createDocumentMaster,
    getDocumentMasterSlug,
    ...state,
  };
};

export default useDocumentMaster;
